import { Box } from "@mui/material";

import { COMMON_COPY } from "copy/common";
import { useCopy } from "i18n/useCopy";

/**
 * PageLoader Component
 * Displays a loading spinner while the app is initializing.
 * This component is intentionally auth-agnostic to support both public and protected pages.
 */
const PageLoader = (): React.ReactElement => {
  const copy = useCopy();

  return (
    <Box sx={styles.container}>
      <div style={styles.spinner}></div>
      <p>{copy.text(COMMON_COPY.states.loading)}</p>
    </Box>
  );
};

export default PageLoader;

// Inline styles for simplicity
const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f5f5f5",
    color: "#333",
  },
  spinner: {
    width: "50px",
    height: "50px",
    border: "5px solid #ccc",
    borderTop: "5px solid #007bff",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },
};
